import layout from '@/components/common/layout';
import sabillList from '../views/sabill/list';

export default [
    {
        path: '/sabill',
        component: layout,
        children: [
            {
                path: 'list',
                meta: {
                    metaInfo: {
                        title: "工资账单",
                        keywords: "",
                        description: ""
                    },
                    requireLogin: true,
                    menu: {
                        parent: '12',// 父选项
                        child: 'sabill_list',// 子选项
                    }
                },
                component: sabillList,
            },
        ]
    },
];
